<template>
  <div>
    <top-header :type="6" placeholder="成交记录" fontSize="0.32rem"/>
    <div class="record_list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="" />
          </div>
          <div class="row" v-for="(item, index) in list" :key="index">
            <div class="m_flex_box flex_vc flex_jz">
              <h5 class="m_flex_box flex_vc">{{item.sumArea}}m²/{{item.houseUse}}</h5>
              <span>{{item.contrTypeStr}}</span>
            </div>
            <p class="m_flex_box">
              <span>备案时间 {{item.contrRaffirmTime}}</span>
              <span>核验编码 {{item.uniqueCode}}</span>
            </p>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      timer: null,
      formData:{
        itemId: this.$route.query.itemId,
      }
    };
  },
  components: {
    topHeader
  },
  mounted() {
  },
  methods: {
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', [])
      this.onLoad(1);
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http.post('cms/xzhouse/permit/getEsfSignList.do', qs.stringify(this.formData)).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = res.obj.signList;
            this.loading = false;
            this.finished = true;
          } else {
            this.finished = true;
          }
        })
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pad_top{
  padding-top: 0.9rem;
}
.record_list{
  width: 7.04rem;
  margin: 0 auto;
  .row{
    padding: 0.3rem 0;
    border-bottom: 1px solid #f5f5f5;
    &:last-child{
      padding-bottom: 0;
      border: 0
    }
    div{
      h5{
        font-size: 0.3rem;
        color: #1E1E1E;
        &:before{
          content: '';
          display: block;
          width: 0.14rem;
          height: 0.14rem;
          border-radius: 50%;
          background-color: #E0E0E0;
          margin-right: 0.14rem;
        }
      }
      span{
        font-size: 0.22rem;
        color: #FF5730;
        border: 1px solid currentColor;
        padding: 0.02rem 0.04rem;
        border-radius: 0.04rem;
      }
    }
    p{
      padding-left: 0.28rem;
      margin-top: 0.2rem;
      font-size: 0.24rem;
      color:#A0A0A0;
      span{
        margin-right: 0.2rem;
      }
    }
  }
}
</style>